export * from "../global/external-link";
